<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Fassade</h2>
      <p class="step-text">Wie ist die Fassade aufgebaut?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Gegliederte Fassade<br/>Klassischer Altbau"
          @click="setFassade(30)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8279.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8279_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Glatte Fassade<br/>Zwischenkriegszeit"
          @click="setFassade(20)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8282.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8282_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-20"
          text="Nicht bekannt"
          @click="setFassade(10)"
          :iconDefault="require('@/assets/icons/Svgs/Pfad_7646.svg')"
          :iconHover="require('@/assets/icons/Svgs/Pfad_7646_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "dg-wohnung-step-4",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexArtFassade: { value: null },
      },
    };
  },
  methods: {
    setFassade(index) {
      this.fields.indexArtFassade.value = index;
      saveToStorage(this.fields);
      this.$router.push("/dg-wohnung-step-5");
    },
    goBack() {
      this.$router.push("/dg-wohnung-step-3");
    },
  },
  mounted() {
    this.$emit("setStep", "dg-wohnung", 5);
  },
};
</script>
